export type HitlCategory =
  | "booking"
  | "crm"
  | "publicist"
  | "marketing"
  | "manager"
  | "routing"
  | "accounting"
  | "general";

export type HitlStatus = "pending" | "approved" | "rejected" | "changes_requested";

export type HitlPriority = "low" | "normal" | "medium" | "high" | "urgent";

export interface HitlTimelineEntry {
  id?: string;
  timestamp?: string | null;
  summary?: string | null;
  event_type?: string | null;
  actor?: string | null;
}

export interface HitlRelatedLink {
  type: string;
  label: string;
  href: string;
  external?: boolean;
}

export interface HitlItem {
  id: string;
  title?: string | null;
  summary?: string | null;
  description?: string | null;
  category?: HitlCategory | string | null;
  status: HitlStatus;
  agent?: string | null;
  workflow_id?: string | null;
  workflow?: string | null;
  thread_id?: string | null;
  node_key?: string | null;
  priority?: HitlPriority | null;
  deadline?: string | null;
  assigned_to?: string | null;
  assigned_to_me?: boolean;
  assigned_to_display?: string | null;
  created_by_agent?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  source?: string | null;
  payload?: Record<string, unknown> | null;
  metadata?: Record<string, unknown> | null;
  tags?: string[] | null;
  related_links?: HitlRelatedLink[];
  timeline?: HitlTimelineEntry[];
  context?: Record<string, unknown> | null;
}

export interface HitlInboxFilters {
  category?: HitlCategory | "all" | null;
  status?: HitlStatus | "all" | null;
  mineOnly?: boolean;
  assigned_to?: string | null;
  limit?: number;
}

export const HITL_CATEGORIES: { id: HitlCategory | "all"; label: string }[] = [
  { id: "all", label: "All" },
  { id: "booking", label: "Booking" },
  { id: "crm", label: "CRM" },
  { id: "publicist", label: "Publicist" },
  { id: "marketing", label: "Marketing" },
  { id: "manager", label: "Manager" },
  { id: "routing", label: "Routing" },
  { id: "accounting", label: "Accounting" },
  { id: "general", label: "General" },
];
